import PropTypes from 'prop-types';
import './Header.scss';

export const Header = ({
  text, extraStyle = '', style,
}) => (<h2 className={`${extraStyle}`} style={style}>{text}</h2>);

Header.propTypes = {
  text: PropTypes.string.isRequired,
  extraStyle: PropTypes.string,
  style: PropTypes.object,
};
